// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1VFHY","productName":"Table_productName__TD_QE"};